import React from "react";

const OPrint = ({ referenceId }) => {
  const handlePrint = () => {
    const printContent = document.getElementById(referenceId);
    if (!printContent) {
      console.error(`No se encontró el elemento con id '${referenceId}'`);
      return;
    }
    const printClone = printContent.cloneNode(true);
    const printWindow = window.open("", "_blank");

    const styles = Array.from(
      document.querySelectorAll('style, link[rel="stylesheet"]')
    )
      .map((style) => style.outerHTML)
      .join("");

    printWindow.document.write(`
              <html>
                  <head>
                      <title>Imprimir</title>
                      ${styles} 
                  </head>
                  <body>
                      <div id="print-container">
                          ${printClone.outerHTML}
                      </div>
                  </body>
              </html>
          `);

    printWindow.document.close();

    printWindow.onload = () => {
      printWindow.print();

      printWindow.onafterprint = () => {
        printWindow.close();
      };
    };
  };

  return (
    <button
      type="button"
      onClick={handlePrint}
      className="btn btn-success waves-effect waves-light float-end mb-3"
    >
      <i className="icon-printer align-middle me-2"></i> Imprimir
    </button>
  );
};

export default OPrint;
